/**
 * Cookie consent
 * Buttons marked `data-cookie-consent` (the YouTube placeholder) reopen the
 * Cookiebot banner, so a visitor can accept marketing cookies right where the
 * blocked content is. Cookiebot itself then loads the iframe and hides the
 * placeholder.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $$ } from "@utils/dom";
export const initCookieConsent = () => {
    $$("[data-cookie-consent]").forEach((button) => {
        button.addEventListener("click", () => {
            if (!globalThis.Cookiebot) {
                console.error("Cookiebot is not loaded; cannot open the consent banner.");
                return;
            }
            globalThis.Cookiebot.renew();
        });
    });
};
